export const FALLBACK_APP_VERSION = '4.42.0';
